/* Progressive enhancement: keep policy copy and existing anchor IDs intact. */
(() => {
  const script = document.currentScript;
  const container = document.querySelector('.shopify-policy__container');
  const body = container?.querySelector('.shopify-policy__body');
  if (!body || container.dataset.helpReady) return;
  container.dataset.helpReady = 'true';
  const rte = body.querySelector('.rte') || body;
  if (!rte.querySelector('h2')) {
    rte.querySelectorAll(':scope > h5.wp-block-heading').forEach(heading => {
      heading.setAttribute('role', 'heading');
      heading.setAttribute('aria-level', '2');
    });
  }
  // Legacy terms use bold labels inside the top-level list instead of headings.
  if (!rte.querySelector('h2, [role="heading"]')) {
    rte.querySelectorAll(':scope > ol > li > strong:first-child, :scope > p > strong:only-child').forEach(label => {
      if (label.textContent.trim().length > 110) return;
      label.setAttribute('role', 'heading');
      label.setAttribute('aria-level', '2');
    });
  }
  const headings = [...rte.querySelectorAll('h2, [role="heading"][aria-level="2"]')];
  // Reuse the merchant's own shipping summary, with no duplicated policy wording.
  if (location.pathname === '/policies/shipping-policy') {
    const summary = headings.find(h => h.textContent.trim() === 'Quick Shipping Summary');
    if (summary && summary.parentElement === rte) {
      const panel = document.createElement('section');
      panel.className = 'etr-help__summary';
      let next = summary.nextSibling;
      panel.append(summary);
      while (next && !(next.nodeType === 1 && /^H[12]$/.test(next.tagName))) {
        const following = next.nextSibling;
        panel.append(next);
        next = following;
      }
      rte.prepend(panel);
    }
  }
  if (headings.length >= 4) {
    const grid = document.createElement('div');
    grid.className = 'etr-help__policy-grid';
    const nav = document.createElement('nav');
    const label = script?.dataset.contentsLabel || 'On this page';
    nav.setAttribute('aria-label', label);
    const disclosure = document.createElement('details');
    disclosure.className = 'etr-help__contents';
    disclosure.open = matchMedia('(min-width: 900px)').matches;
    const summary = document.createElement('summary');
    summary.textContent = label;
    const list = document.createElement('ul');
    [...rte.querySelectorAll('h2, [role="heading"][aria-level="2"]')].forEach((heading, index) => {
      if (!heading.id) {
        let id = `et-help-section-${index + 1}`;
        while (document.getElementById(id)) id += '-section';
        heading.id = id;
      }
      heading.tabIndex = -1;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      link.addEventListener('click', () => heading.focus({ preventScroll: true }));
      item.append(link); list.append(item);
    });
    disclosure.append(summary, list); nav.append(disclosure);
    body.before(grid); grid.append(nav, body);
  }
  const contact = document.createElement('a');
  contact.className = 'etr-help__contact';
  contact.href = '/pages/contact';
  contact.textContent = script?.dataset.contactLabel || 'Need a hand? Contact our team';
  container.querySelector('.shopify-policy__title')?.append(contact);
})();
